import React, { useEffect } from 'react'
import { Navigate, useParams } from 'react-router-dom'

import { RouteParams, Routes } from 'meta/routes'
import { useAppDispatch } from 'store'
import { CollectionActions } from 'store/pages/collection'

import withTranslation from 'components/HOC/WithTranslation'
import { useIsAppInitialized } from 'hooks/useApp'
import { useCurrentLanguage } from 'hooks/useCurrentLanguage'

import Wrapper from '../Wrapper/Wrapper'

const CollectionIFrame: React.FC = () => {
  const { id } = useParams<RouteParams['Collection']>()

  const dispatch = useAppDispatch()
  const appInitialized = useIsAppInitialized()

  const language = useCurrentLanguage()

  useEffect(() => {
    if (appInitialized && id) {
      dispatch(CollectionActions.getData({ collectionId: id }))
      dispatch(CollectionActions.getActiveEvents({ collectionId: id, page: 1 }))
      dispatch(CollectionActions.getActiveTypeticketcollections({ collectionId: id, page: 1 }))
    }
  }, [id, dispatch, appInitialized, language])

  if (!id) {
    return <Navigate to={Routes.Home.generatePath()} />
  }

  return <Wrapper id={id} fromIframe />
}

const namespaces = ['collection', 'event']

export default withTranslation(namespaces)(CollectionIFrame)
